<template>
  <nav class="navbar">
    <nav class="navbar is-transparent is-dark container">
      <div class="navbar-brand menu-logo">
        <img
          class="logo"
          width="auto"
          height="auto"
          :src="`${!isStatic? logo: '../static/HSBC_MASTERBRAND_LOGO_RGB_NEG.png'}`"
          :alt="alt"
          :title="title"
        >
      </div>

      <div class="navbar-menu">
        <div class="navbar-start"></div>
        <div class="navbar-end">
          <language-select class="navbar-item" :dark-theme="true" :lang-root="`langSelector`"></language-select>
        </div>
      </div>

      <div class="navbar-item" v-if="linkingUser">
        <div class="user has-text-right" id="headerUser">
          <a class="navbar-item" data-ci="user-profile">
            <strong>
              {{buyerName}}
            </strong>
          </a>
        </div>
      </div>
      <div class="navbar-item" id="logout" v-if="linkingUser">
        <button
          type="button"
          @click="logout"
          data-ci="logout-button"
          id="logoutButton"
          v-t="`header.logoutBtn`"
        />
      </div>
    </nav>
  </nav>
</template>


<script>
import Vue from 'vue';
import i18n from '@shared/locale/locale';
import LanguageSelect from '@shared/components/LanguageSelect';
import { mapState, mapActions } from 'vuex';
import logo from '../images/HSBC_MASTERBRAND_LOGO_RGB_NEG.png';

const name = 'ii-header';

export default {
    name,
    componentName: name,
    components: {
        [LanguageSelect.name]: LanguageSelect,
    },
    props: {
      isStatic: { type: Boolean, default: false },
    },
    data() {
        return {
            showLocales: false,
            showDebug: false,
            title: this.$t('header.logo.title'),
            alt: this.$t('header.logo.alt'),
            logo
        };
    },
    computed: {
      ...mapState('loggedIn', ['isResuming', 'buyerName', 'linkingUser']),
    },
    methods: {
      ...mapActions('loggedIn', ['logout']),
    },
};
</script>



// WEBPACK FOOTER //
// shared/components/Header.vue